---
title: إعداد البريد الإلكتروني وصندوق البريد
parent: المستندات
parentHref: /docs
---

# إعداد صندوق البريد الإلكتروني الخاص بك

تتضمن خطة TOBY الخاصة بك عنوان بريد إلكتروني احترافي يطابق نطاقك (على سبيل المثال، info@your-domain.de) مع **صندوق بريد بسعة 15 جيجابايت (Maxi-Postfach)**، بالإضافة إلى عناوين إعادة توجيه بريد إلكتروني غير محدودة. هل تحتاج إلى المزيد من صناديق البريد أو مساحة تخزين إضافية؟ يمكنك إضافة صندوق بريد آخر بسعة 15 جيجابايت في أي وقت — راجع [قائمة الأسعار](/ar/pricing).

## 1. إنشاء صندوق البريد الخاص بك في TOBY

1. افتح **الإعدادات ← البريد الإلكتروني** في TOBY.
2. اختر العنوان الذي تريده (مثل info@، أو hello@، أو contact@) وأنشئ صندوق البريد.
3. **انسخ كلمة المرور الخاصة بك:** يعرض TOBY كلمة مرور صندوق البريد المُنشأة مرة واحدة فقط مباشرة بعد الإنشاء. انسخها أو احفظها قبل إغلاق النافذة. (إذا فقدتها في أي وقت، يمكنك إنشاء كلمة مرور جديدة بنقرة واحدة ضمن **الإعدادات ← البريد الإلكتروني** — ستبقى رسائل البريد الإلكتروني الموجودة آمنة.)

## 2. قراءة وإرسال البريد الإلكتروني في المتصفح (البريد الإلكتروني عبر الويب)

يمكنك فتح صندوق الوارد الخاص بك من أي متصفح كمبيوتر أو هاتف دون تثبيت تطبيق:

- **عنوان البريد الإلكتروني عبر الويب:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **اسم المستخدم:** عنوان بريدك الإلكتروني الكامل (مثل info@your-domain.de)
- **كلمة المرور:** كلمة مرور صندوق البريد من **الإعدادات ← البريد الإلكتروني**

## 3. ربط هاتفك أو جهاز الكمبيوتر الخاص بك (IMAP و SMTP)

لقراءة وإرسال رسائل البريد الإلكتروني في **Apple Mail (آيفون، آيباد، ماك)**، أو **Gmail / Android Mail**، أو **Outlook**، أو **Thunderbird**، أضف حساب **IMAP** جديدًا في تطبيق البريد الخاص بك وأدخل إعدادات الخادم التالية:

| الإعداد | القيمة |
| --- | --- |
| **نوع الحساب** | IMAP |
| **عنوان البريد الإلكتروني / اسم المستخدم** | عنوان بريدك الإلكتروني الكامل (مثل info@your-domain.de) |
| **كلمة المرور** | كلمة مرور صندوق البريد من الإعدادات ← البريد الإلكتروني |
| **خادم البريد الوارد (IMAP)** | mail.tobysite.com |
| **منفذ البريد الوارد** | 993 (SSL/TLS) |
| **خادم البريد الصادر (SMTP)** | mail.tobysite.com |
| **منفذ البريد الصادر** | 465 (SSL/TLS) أو 587 (STARTTLS) |

> **مهم:** تأكد من إدخال **عنوان بريدك الإلكتروني الكامل** (بما في ذلك @your-domain.de) كاسم مستخدم **لكل من** خادم البريد الوارد (IMAP) والصادر (SMTP).

### خطوة بخطوة على آيفون وآيباد (iOS Mail)

1. افتح تطبيق **الإعدادات** في الآيفون ← **التطبيقات** ← **البريد** ← **حسابات البريد** ← **إضافة حساب** ← **أخرى** ← **إضافة حساب بريد**.
2. أدخل اسمك، وعنوان بريدك الإلكتروني الكامل، وكلمة مرور صندوق البريد، ووصف قصير. اضغط على **التالي**.
3. احتفظ بـ **IMAP** محددًا في الأعلى.
4. تحت **خادم البريد الوارد** و **خادم البريد الصادر**، أدخل mail.tobysite.com كاسم المضيف، وعنوان بريدك الإلكتروني الكامل كاسم المستخدم، وكلمة مرور صندوق البريد.
5. اضغط على **التالي** ثم **حفظ**.

### خطوة بخطوة على أندرويد (تطبيق Gmail)

1. افتح تطبيق **Gmail**، اضغط على صورة ملفك الشخصي في الزاوية العليا اليمنى ← **إضافة حساب آخر** ← **أخرى**.
2. أدخل عنوان بريدك الإلكتروني الكامل واضغط على **الإعداد اليدوي** ← **شخصي (IMAP)**، ثم أدخل كلمة المرور الخاصة بك.
3. لـ **الخادم الوارد**، اضبط الخادم على mail.tobysite.com، والمنفذ 993، ونوع الأمان SSL/TLS.
4. لـ **خادم SMTP الصادر**، اضبط الخادم على mail.tobysite.com، والمنفذ 465 (SSL/TLS)، وتأكد من تمكين **يتطلب تسجيل الدخول** مع عنوان بريدك الإلكتروني الكامل.
5. اضغط على **التالي** للإنهاء.

التالي: [النشرة الإخبارية والإعلانات](/ar/docs/newsletter).
